// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"3097a1b7","197":"413b2e90","622":"075d0133","725":"1b31faac","769":"c45f9dd3","942":"afcfb1b7"}[chunkId] + ".chunk.js";
};